export const DROPDOWN_TYPES = {
  ActivitiesType: 'activitiesType',
  StoreSelector: 'storeSelector',
  Actions: 'actions',
  Schedule: 'schedule',
  SalesTargetType: 'salesTargetType',
  Segments: 'segments',
}
